export default "__VITE_ASSET__e959f073__"